import moment from 'moment';

/**
 * This method parses information extracted from server in order to make it match
 * with structure needed in simple_flight view
 *
 * @param {Object} serverData
 * @returns {Object} iataList: [], flightsInfo : {}
 */
const parseOfferDataToEdit = (serverData) => {
  const parsedInformation = {
    amenities: {},
    flightsInfo: {},
    iataList: [],
  };

  parsedInformation.amenities = serverData.amenities;
  parsedInformation.providers = serverData.providers;

  parsedInformation.iataList = serverData.departure_data.map((depData) => {
    const currentDepartureIata = depData.departure_iata;
    const currentArrivalIata = depData.destination_iata;
    parsedInformation.flightsInfo[currentDepartureIata] = depData.flights.map((savedFlight) => (
      {
        departure_date: moment(savedFlight.departure_date),
        arrival_date: moment(savedFlight.arrival_date) || null,
        special_date: savedFlight.special_date,
        weekend: savedFlight.weekend,
        price: savedFlight.price,
        connections: savedFlight.connections,
        currency: serverData.currency,
        promo_code: savedFlight.promo_code,
        provider: savedFlight.provider,
        provider_permalink: savedFlight.provider_permalink,
        expired: savedFlight.expired,
        departure_iata: currentDepartureIata,
        arrival_iata: currentArrivalIata,
        comment: savedFlight.comment || '',
        adults: savedFlight.adults || 0,
        youngs: savedFlight.youngs || 0,
        childs: savedFlight.childs || 0,
        hotel_code: savedFlight.hotel_code || '',
        hotel_name: savedFlight.hotel_name || '',
        origin_id: savedFlight.origin_id || '',
        destination_id: savedFlight.destination_id || '',
        mapping_id: savedFlight.mapping_id || '',
        mapping_type: savedFlight.mapping_type || '',
      }
    ));
    return currentDepartureIata;
  });

  return parsedInformation;
};

export default parseOfferDataToEdit;
